import Cookies from 'js-cookie';
const TokenKey = 'Admin-Token';

const TenantKey = 'Admin-Tenant';

export function getToken() {
    // return Cookies.get(TokenKey);
    return sessionStorage.getItem(TokenKey);
}

export function setToken(token) {
    // return Cookies.set(TokenKey, token);
    return sessionStorage.setItem(TokenKey, token);
}

export function removeToken() {
    // return Cookies.remove(TokenKey);
    return sessionStorage.removeItem(TokenKey);
}

export function getTenant() {
    // return Cookies.get(TenantKey);
    return sessionStorage.getItem(TenantKey);
}

export function setTenant(token) {
    // return Cookies.set(TenantKey, token);
    return sessionStorage.setItem(TenantKey, token);
}

export function removeTenant() {
    // return Cookies.remove(TenantKey);
    return sessionStorage.removeItem(TenantKey);
}
// ============
// 缓存

export function getCookies(cookieKey) {
    return Cookies.get(cookieKey);
}

export function setCookies(cookieKey, cookieValue) {
    return Cookies.set(cookieKey, cookieValue);
}

export function removeCookies(cookieKey) {
    return Cookies.remove(cookieKey);
}

export function setLocalToken(token) {
    return localStorage.setItem(TokenKey, token);
}

export function getLocalToken() {
    return localStorage.getItem(TokenKey);
}

export function removeLocalToken() {
    return localStorage.removeItem(TokenKey);
}

export function setAloneToken(token) {
    return sessionStorage.setItem(TokenKey, token);
}

export function getAloneToken() {
    return sessionStorage.getItem(TokenKey);
}

export function removeAloneToken() {
    return sessionStorage.removeItem(TokenKey);
}

export function setAloneCookies(cookiesKey, cookiesValue) {
    return sessionStorage.setItem(cookiesKey, cookiesValue);
}

export function getAloneCookies(cookiesKey) {
    return sessionStorage.getItem(cookiesKey);
}

export function removeAloneCookies(cookiesKey) {
    return sessionStorage.removeItem(cookiesKey);
}
